// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Label from "../../primitives/Label.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Request from "../../core/Request.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as IconButton from "../../resources/actions/IconButton.res.js";
import * as StackFields from "../../resources/layout-and-structure/StackFields.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
import * as FieldsetLayoutPanel from "../../resources/layout-and-structure/FieldsetLayoutPanel.res.js";
import * as ResourceDetailsPage from "../../core/ResourceDetailsPage.res.js";
let endpoint = Env.gatewayUrl() + "/auth/password-update";
function encodeBody(currentPassword, newPassword) {
  return Json.encodeDict(Object.fromEntries([["currentPassword", Json.encodeString(currentPassword)], ["newPassword", Json.encodeString(newPassword)]]));
}
function decodeInvalidRequestFailure(error) {
  if (error.kind === "WrongUserPassword") {
    return "WrongUserPassword";
  } else {
    return "UnknownServerFailure";
  }
}
function make(currentPassword, newPassword) {
  return Future.mapError(Request.make(endpoint, "POST", {
    TAG: "JsonBody",
    _0: encodeBody(currentPassword, newPassword)
  }, undefined, undefined), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return;
    } else {
      return Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure);
    }
  });
}
let UpdatePasswordRequest = {
  endpoint: endpoint,
  encodeBody: encodeBody,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure,
  make: make
};
function get(values, field) {
  switch (field) {
    case "CurrentPassword":
      return values.currentPassword;
    case "NewPassword":
      return values.newPassword;
    case "NewPasswordConfirmation":
      return values.newPasswordConfirmation;
  }
}
function set(values, field, value) {
  switch (field) {
    case "CurrentPassword":
      return {
        currentPassword: value,
        newPassword: values.newPassword,
        newPasswordConfirmation: values.newPasswordConfirmation
      };
    case "NewPassword":
      return {
        currentPassword: values.currentPassword,
        newPassword: value,
        newPasswordConfirmation: values.newPasswordConfirmation
      };
    case "NewPasswordConfirmation":
      return {
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
        newPasswordConfirmation: value
      };
  }
}
let EditPasswordFormLenses_ = {
  get: get,
  set: set
};
let EditPasswordFormLenses = {
  get: get,
  set: set
};
let EditPasswordForm = Form.Make(EditPasswordFormLenses);
let schema = [{
  TAG: "StringNotEmpty",
  _0: "CurrentPassword"
}, {
  TAG: "Password",
  _0: "NewPassword"
}, {
  TAG: "StringNotEmpty",
  _0: "NewPasswordConfirmation"
}, {
  TAG: "CustomString",
  _0: "NewPasswordConfirmation",
  _1: (value, values) => {
    if (values.newPassword === value) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: I18n.t("Password and its confirmation must be identical")
      };
    }
  }
}];
function SettingsUserPage$EditPasswordFormModal(props) {
  let updatePasswordRequest = props.updatePasswordRequest;
  let onNotification = props.onNotification;
  let onRequestClose = props.onRequestClose;
  let match = React.useState(() => {});
  let setError = match[1];
  let error = match[0];
  let onSubmit = (param, param$1) => Future.mapError(Future.mapOk(updatePasswordRequest(param$1.currentPassword, param$1.newPassword), undefined, param => I18n.t("Your user and account information has been successfully updated.")), undefined, error => {
    if (error === "WrongUserPassword") {
      return I18n.t("Wrong user password provided.");
    } else {
      return I18n.t("An unexpected error occured. Please try again or contact the support.");
    }
  });
  let onSubmitSuccess = param => {
    let success = I18n.t("Your user and account information has been successfully updated.");
    onNotification({
      TAG: "Success",
      _0: success
    });
    onRequestClose();
  };
  let onSubmitFailure = message => setError(param => message);
  let formPropState = EditPasswordForm.useFormPropState({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      newPasswordConfirmation: ""
    },
    schema: schema,
    resetValuesAfterSubmission: true,
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsxs(EditPasswordForm.Core.Provider.make, {
      children: [error !== undefined ? JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(Banner.make, {
          textStatus: {
            TAG: "Danger",
            _0: error
          },
          onRequestClose: () => setError(param => {})
        }),
        spaceX: "xlarge",
        spaceTop: "large"
      }) : null, JsxRuntime.jsxs(Box.make, {
        children: [JsxRuntime.jsxs(StackFields.make, {
          children: [JsxRuntime.jsx(EditPasswordForm.InputPassword.make, {
            field: "CurrentPassword",
            label: I18n.t("Current password"),
            placeholder: I18n.t("Enter your current password"),
            hideError: true,
            hideRequired: true
          }), JsxRuntime.jsx(EditPasswordForm.InputPassword.make, {
            field: "NewPassword",
            label: I18n.t("New password"),
            placeholder: I18n.t("Enter your new password"),
            hideRequired: true,
            showTypingValidation: true
          }), JsxRuntime.jsx(EditPasswordForm.InputPassword.make, {
            field: "NewPasswordConfirmation",
            label: I18n.t("New password confirmation"),
            placeholder: I18n.t("Confirm your new password"),
            hideRequired: true
          })]
        }), JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsxs(Inline.make, {
            children: [JsxRuntime.jsx(Button.make, {
              label: I18n.t("Cancel"),
              onPress: () => onRequestClose()
            }), JsxRuntime.jsx(EditPasswordForm.SubmitButton.make, {
              label: I18n.t("Save"),
              onSubmit: onSubmit
            })],
            space: "normal",
            align: "end"
          }),
          spaceY: "xlarge"
        })],
        spaceX: "xlarge",
        spaceTop: "xlarge"
      })],
      propState: formPropState
    }),
    opened: props.opened,
    title: I18n.t("Update password"),
    hideFooter: true,
    onRequestClose: onRequestClose
  });
}
let make$1 = React.memo(SettingsUserPage$EditPasswordFormModal);
let EditPasswordFormModal = {
  schema: schema,
  make: make$1
};
function encodeBody$1(newUsername, password) {
  return Json.encodeDict(Object.fromEntries([["newUsername", Json.encodeString(newUsername)], ["password", Json.encodeString(password)]]));
}
let endpoint$1 = Env.gatewayUrl() + "/auth/username-update";
function decodeInvalidRequestFailure$1(error) {
  switch (error.kind) {
    case "DuplicateUserUsername":
      return "DuplicateUserUsername";
    case "WrongUserPassword":
      return "WrongUserPassword";
    default:
      return "UnknownServerFailure";
  }
}
function make$2(newUsername, password) {
  return Future.mapError(Request.make(endpoint$1, "POST", {
    TAG: "JsonBody",
    _0: encodeBody$1(newUsername, password)
  }, undefined, undefined), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return;
    } else {
      return Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure$1);
    }
  });
}
let UpdateEmailRequest = {
  encodeBody: encodeBody$1,
  endpoint: endpoint$1,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure$1,
  make: make$2
};
function get$1(values, field) {
  if (field === "NewUsername") {
    return values.newUsername;
  } else {
    return values.password;
  }
}
function set$1(values, field, value) {
  if (field === "NewUsername") {
    return {
      newUsername: value,
      password: values.password
    };
  } else {
    return {
      newUsername: values.newUsername,
      password: value
    };
  }
}
let EditEmailFormLenses_ = {
  get: get$1,
  set: set$1
};
let EditEmailFormLenses = {
  get: get$1,
  set: set$1
};
let EditEmailForm = Form.Make(EditEmailFormLenses);
let schema$1 = [{
  TAG: "Email",
  _0: "NewUsername"
}, {
  TAG: "StringNotEmpty",
  _0: "Password"
}];
function SettingsUserPage$EditEmailModal(props) {
  let updateEmailRequest = props.updateEmailRequest;
  let onNotification = props.onNotification;
  let onRequestClose = props.onRequestClose;
  let logUser = Auth.useLogUser(undefined, undefined);
  let jwt = Stdlib_Option.getOr(Auth.getJwt(), "");
  let match = React.useState(() => {});
  let setError = match[1];
  let error = match[0];
  let onSubmit = (param, param$1) => Future.mapError(Future.mapOk(updateEmailRequest(param$1.newUsername, param$1.password), undefined, param => I18n.t("Your email address has been updated successfully.")), undefined, failure => {
    if (failure === undefined) {
      return I18n.t("An unexpected error occured. Please try again or contact the support.");
    }
    switch (failure) {
      case "DuplicateUserUsername":
        return I18n.t("This email address is already used.");
      case "WrongUserPassword":
        return I18n.t("Wrong user password provided.");
      case "UnknownServerFailure":
        return I18n.t("An unexpected error occured. Please try again or contact the support.");
    }
  });
  let onSubmitSuccess = param => {
    logUser(jwt);
    onNotification({
      TAG: "Warning",
      _0: I18n.t("You will receive a link by email to confirm the email address change within a few minutes.")
    });
    onRequestClose();
  };
  let onSubmitFailure = message => setError(param => message);
  let formPropState = EditEmailForm.useFormPropState({
    initialValues: {
      newUsername: props.currentUsername,
      password: ""
    },
    schema: schema$1,
    resetValuesAfterSubmission: true,
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsxs(EditEmailForm.Core.Provider.make, {
      children: [error !== undefined ? JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(Banner.make, {
          textStatus: {
            TAG: "Danger",
            _0: error
          },
          onRequestClose: () => setError(param => {})
        }),
        spaceX: "xlarge",
        spaceTop: "large"
      }) : null, JsxRuntime.jsxs(Box.make, {
        children: [JsxRuntime.jsxs(StackFields.make, {
          children: [JsxRuntime.jsx(EditEmailForm.InputText.make, {
            field: "NewUsername",
            label: I18n.t("Email address"),
            hideRequired: true
          }), JsxRuntime.jsx(EditEmailForm.InputPassword.make, {
            field: "Password",
            label: I18n.t("Current password"),
            placeholder: I18n.t("Enter your current password"),
            hideError: true,
            hideRequired: true
          })]
        }), JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsxs(Inline.make, {
            children: [JsxRuntime.jsx(Button.make, {
              label: I18n.t("Cancel"),
              onPress: () => onRequestClose()
            }), JsxRuntime.jsx(EditEmailForm.SubmitButton.make, {
              label: I18n.t("Save"),
              tone: "success",
              onSubmit: onSubmit
            })],
            space: "normal",
            align: "end"
          }),
          spaceY: "xlarge"
        })],
        spaceX: "xlarge",
        spaceTop: "xlarge"
      })],
      propState: formPropState
    }),
    opened: props.opened,
    title: I18n.t("Update email"),
    hideFooter: true,
    onRequestClose: onRequestClose
  });
}
let make$3 = React.memo(SettingsUserPage$EditEmailModal);
let EditEmailModal = {
  schema: schema$1,
  make: make$3
};
function SettingsUserPage$EditEmailAndPasswordFieldset(props) {
  let onNotification = props.onNotification;
  let username = props.username;
  let match = React.useState(() => false);
  let setUpdatePasswordModalOpened = match[1];
  let match$1 = React.useState(() => false);
  let setUpdateUsernameModalOpened = match$1[1];
  let handleEmailClick = param => {
    setUpdateUsernameModalOpened(param => true);
    onNotification(undefined);
  };
  let handlePasswordClick = param => {
    setUpdatePasswordModalOpened(param => true);
    onNotification(undefined);
  };
  let newrecord = {
    ...{
      style: {
        marginTop: "-8px"
      }
    }
  };
  let newrecord$1 = {
    ...{
      style: {
        marginTop: "-8px"
      }
    }
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx(FieldsetLayoutPanel.make, {
      title: I18n.t("Login details"),
      description: I18n.t("To update your login credentials, you will need to enter your current password and confirm the changes through a link sent to your current email inbox."),
      children: JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(Label.make, {
            text: I18n.t("Email address")
          }), JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsxs(Inline.make, {
            children: [JsxRuntime.jsx(TextStyle.make, {
              children: username
            }), JsxRuntime.jsx(IconButton.make, {
              name: "edit_light",
              marginSize: "small",
              color: "#07061e",
              hoveredColor: "#8a0262",
              onPress: handleEmailClick
            })]
          }), newrecord))],
          space: "none"
        }), JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(Label.make, {
            text: I18n.t("Password")
          }), JsxRuntime.jsx("div", (newrecord$1.children = JsxRuntime.jsxs(Inline.make, {
            children: [JsxRuntime.jsx(TextStyle.make, {
              children: "● ● ● ● ● ● ● ● ● ● ● ● "
            }), JsxRuntime.jsx(IconButton.make, {
              name: "edit_light",
              marginSize: "small",
              color: "#07061e",
              hoveredColor: "#8a0262",
              onPress: handlePasswordClick
            })]
          }), newrecord$1))],
          space: "none"
        })],
        space: "small"
      })
    }), JsxRuntime.jsx(make$3, {
      onRequestClose: () => setUpdateUsernameModalOpened(param => false),
      opened: match$1[0],
      currentUsername: username,
      onNotification: onNotification,
      updateEmailRequest: props.updateEmailRequest
    }), JsxRuntime.jsx(make$1, {
      onRequestClose: () => setUpdatePasswordModalOpened(param => false),
      opened: match[0],
      onNotification: onNotification,
      updatePasswordRequest: props.updatePasswordRequest
    })]
  });
}
let make$4 = React.memo(SettingsUserPage$EditEmailAndPasswordFieldset);
let EditEmailAndPasswordFieldset = {
  make: make$4
};
function get$2(values, field) {
  if (field === "Name") {
    return values.name;
  } else {
    return values.organizationName;
  }
}
function set$2(values, field, value) {
  if (field === "Name") {
    return {
      name: value,
      organizationName: values.organizationName
    };
  } else {
    return {
      name: values.name,
      organizationName: value
    };
  }
}
let EditUserNamesFormLenses_ = {
  get: get$2,
  set: set$2
};
let EditUserNamesFormLenses = {
  get: get$2,
  set: set$2
};
let EditUserNamesForm = Form.Make(EditUserNamesFormLenses);
function encodeBody$2(name, organizationName) {
  return Json.encodeDict(Object.fromEntries([["name", Json.encodeString(name)], ["organizationName", Json.encodeString(organizationName)]]));
}
let endpoint$2 = Env.gatewayUrl() + "/user";
function make$5(name, organizationName) {
  return Request.make(endpoint$2, "PATCH", {
    TAG: "JsonBody",
    _0: encodeBody$2(name, organizationName)
  }, undefined, undefined);
}
let UpdateUserNamesRequest = {
  encodeBody: encodeBody$2,
  endpoint: endpoint$2,
  make: make$5
};
let schema$2 = [];
function SettingsUserPage$EditUserNamesFieldset(props) {
  let updateUserNamesRequest = props.updateUserNamesRequest;
  let onNotification = props.onNotification;
  let jwt = Stdlib_Option.getOr(Auth.getJwt(), "");
  let logUser = Auth.useLogUser(undefined, undefined);
  let onSubmitSuccess = param => {
    logUser(jwt);
    onNotification({
      TAG: "Success",
      _0: I18n.t("Your user and account information has been successfully updated.")
    });
  };
  let onSubmitFailure = error => onNotification({
    TAG: "Danger",
    _0: error
  });
  let formPropState = EditUserNamesForm.useFormPropState({
    initialValues: {
      name: props.name,
      organizationName: props.organizationName
    },
    schema: schema$2,
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
  let onSubmit = (param, param$1) => {
    onNotification(undefined);
    return Future.mapError(Future.mapOk(updateUserNamesRequest(param$1.name, param$1.organizationName), undefined, param => I18n.t("Your user and account information has been successfully updated.")), undefined, param => I18n.t("An unexpected error occured. Please try again or contact the support."));
  };
  return JsxRuntime.jsx(FieldsetLayoutPanel.make, {
    title: I18n.t("Account name and Username"),
    description: I18n.t("The account name is the name that appears at the top of the interface menu. The username is your name that appears at the bottom of the menu."),
    children: JsxRuntime.jsxs(EditUserNamesForm.Core.Provider.make, {
      children: [JsxRuntime.jsx(EditUserNamesForm.ControlEnterKey.make, {
        onSubmit: onSubmit
      }), JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(EditUserNamesForm.InputText.make, {
          field: "OrganizationName",
          label: I18n.t("Account name")
        }), JsxRuntime.jsx(EditUserNamesForm.InputText.make, {
          field: "Name",
          label: I18n.t("Username"),
          hideError: true
        }), JsxRuntime.jsx(Inline.make, {
          children: JsxRuntime.jsx(EditUserNamesForm.SubmitButton.make, {
            label: I18n.t("Save"),
            tone: "success",
            onSubmit: onSubmit
          }),
          space: "small",
          align: "end"
        })],
        space: "large"
      })],
      propState: formPropState
    })
  });
}
let make$6 = React.memo(SettingsUserPage$EditUserNamesFieldset);
let EditUserNamesFieldset = {
  schema: schema$2,
  make: make$6
};
function SettingsUserPage(props) {
  let match = React.useState(() => {});
  let setNotification = match[1];
  let notification = match[0];
  let auth = Auth.useState();
  let match$1;
  if (typeof auth !== "object" || auth.TAG === "Logging") {
    match$1 = ["", "", ""];
  } else {
    let match$2 = auth._0.user;
    match$1 = [match$2.username, match$2.name, match$2.organizationName];
  }
  let handleNotification = notification => setNotification(param => notification);
  let notificationBanner = notification !== undefined ? JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(Banner.make, {
      textStatus: notification,
      onRequestClose: () => setNotification(param => {})
    }),
    spaceTop: "medium"
  }) : null;
  return JsxRuntime.jsx(ResourceDetailsPage.make, {
    title: I18n.t("Your account"),
    notificationBanner: notificationBanner,
    children: JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsx(make$4, {
        username: match$1[0],
        onNotification: handleNotification,
        updateEmailRequest: props.updateEmailRequest,
        updatePasswordRequest: props.updatePasswordRequest
      }), JsxRuntime.jsx(make$6, {
        name: match$1[1],
        organizationName: match$1[2],
        onNotification: handleNotification,
        updateUserNamesRequest: props.updateUserNamesRequest
      })],
      space: "xlarge"
    })
  });
}
let updatePasswordRequest = make;
let updateEmailRequest = make$2;
let updateUserNamesRequest = make$5;
let make$7 = SettingsUserPage;
export { UpdatePasswordRequest, updatePasswordRequest, EditPasswordFormLenses_, EditPasswordFormLenses, EditPasswordForm, EditPasswordFormModal, UpdateEmailRequest, updateEmailRequest, EditEmailFormLenses_, EditEmailFormLenses, EditEmailForm, EditEmailModal, EditEmailAndPasswordFieldset, EditUserNamesFormLenses_, EditUserNamesFormLenses, EditUserNamesForm, UpdateUserNamesRequest, updateUserNamesRequest, EditUserNamesFieldset, make$7 as make };
/* endpoint Not a pure module */